// ============================================
// HOURLY BREAKDOWN — Tab component for Day Report
// ============================================
import {
    BarChart, Bar, Cell,
    XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from "recharts";
import { CustomTooltip, CHART_COLORS } from "./analyticsHelpers";
import styles from "./DayReport.module.css";

export const DayHourlyBreakdown = ({ hourly }) => {
    const maxVisitors = Math.max(...hourly.map(x => x.visitors), 1);

    return (
        <div className={styles.tabContent}>
            <h3 className={styles.daySectionTitle}>🕐 Visitors by Hour</h3>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={hourly} margin={{ top: 5, right: 5, left: -10, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
                    <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#8C95A4" }} interval={1} />
                    <YAxis tick={{ fontSize: 11, fill: "#8C95A4" }} />
                    <Tooltip content={<CustomTooltip />} />
                    <Bar dataKey="visitors" name="Visitors" radius={[6, 6, 0, 0]} barSize={22}>
                        {hourly.map((entry, i) => (
                            <Cell key={i} fill={entry.visitors > 10 ? CHART_COLORS.BLUE : "#CBD5E1"} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>

            <div className={styles.hourlyGrid}>
                {hourly.map((h, i) => (
                    <div key={i} className={`${styles.hourlyCard} ${h.visitors === 0 ? styles.hourlyCardEmpty : ""}`}>
                        <div className={styles.hourlyLabel}>{h.label}</div>
                        <div className={styles.hourlyValue}>{h.visitors}</div>
                        <div className={styles.hourlyBar}>
                            <div
                                className={styles.hourlyBarFill}
                                style={{
                                    height: `${Math.min((h.visitors / maxVisitors) * 100, 100)}%`,
                                }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
